import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import Info from './UI.Info';
import { Urls } from 'kts-platform-frame/entry/constant';
import { Field } from 'kts-scaffold-framework/utils/doc';
import {Spin, Button, Table, Card} from 'antd';
import Footer from './UI.ViewMatch.Footer';
import { privateDecrypt } from 'crypto';
import {invoiceManage} from 'src/api';
import { history } from 'kts-platform-frame/routes';

const css = require('./index.scss');
const { formatTime, formatDate } = Field;
/** Redux接口 */
interface IReduxStatePart {
    loadingUrls?: Map<Urls, string>;
}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {

}

/** 绑定全局数据到props */
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({
    loadingUrls: state.system.loadingUrls
}))
class Match extends UIBasic<IProps, ModulesState> {
    public columns = [
        {
            title: '发票信息',
            dataIndex: 'itemCode',
            width: 550,
            render: (text, record) => {
                return (
                    <div className="ui-item-description">
                        <div
                            className="ui-item-left-space"
                            title={
                                record.supplierName +
                                ' 录入时间 ' +
                                formatTime(record.loggedDate)
                            }
                        >
                            <span className="supplier-name">
                                {record.supplierName}
                            </span>
                            {/* <span className="log-time">
                                录入时间:{" "}
                                {Lib.Util.Date.formatTime(
                                    record.loggedDate
                                )}
                            </span> */}
                        </div>
                        <div className="ui-item-left-space">
                            <span className="ui-item-info-tertiary">
                                <span>发票代码 </span>
                                <span>{record.invoiceCode}</span>
                            </span>
                            <span className="ui-item-info-tertiary">
                                <span>发票号码 </span>
                                <span>{record.invoiceNumber}</span>
                            </span>
                            <span className="ui-item-info-tertiary">
                                <span>开票日期 </span>
                                <span>
                                    {formatDate(
                                        record.invoiceDate
                                    )}
                                </span>
                            </span>
                        </div>
                    </div>
                );
            }
        },
        {
            title: '金额',
            dataIndex: 'amountWithoutTax',
            width: 180,
            render: (text, record) => {
                return <div>{Field.formatMoney(text, 2)}</div>;
            }
        },
        {
            title: '税额',
            dataIndex: 'amountTax',
            width: 180,
            render: (text, record) => {
                return <div>{Field.formatMoney(text, 2)}</div>;
            }
        },
        {
            title: '价税合计',
            dataIndex: 'amount',
            width: 180,
            render: (text, record) => {
                return <div>{Field.formatMoney(text, 2)}</div>;
            }
        },
        {
            title: '合规状态',
            dataIndex: 'complianceStatus',
            width: 180,
            render: (text, record) => {
                return <div>{text}</div>;
            }
        },
        {
            title: '操作',
            dataIndex: 'amoun',
            width: 140,
            className: 'operate-column text-right',
            render: (text, record) => {
                return (
                    <div>
                        <span
                            className="click-item"
                            onClick={() => this.onDetail(record)}
                        >
                            详 情
                        </span>
                    </div>
                );
            }
        }
    ];

    constructor(props: IProps) {
        super(props, ModulesAction);
    }
    componentDidMount ()  {
        ModulesAction.updateDetail(this.props.match.params.id);
        ModulesAction.updateViewMatchList(this.props.match.params.id);
    }
    

    render() {
        const {loadingUrls} = this.props;
        const extraButtons = (
            <div>
                <Button icon="sync" className="mr10" onClick={()=>{this.refresh();}}>刷新 </Button>
                <Button icon="left" onClick={()=>this.goBack()}>返回 </Button>
            </div>
        );
        return (
            <div className={css.right}>
                <Card title="结算单匹配详情" extra={extraButtons}>
                    <Info />
                    <Spin spinning={ loadingUrls.size>0 }>
                        <Table 
                            columns={this.columns}
                            dataSource={this.modulesState.invoiceList}
                            rowKey={'incomeInvoiceBizId'}
                            pagination={false}
                            scroll={{ x: 1000 }}
                        />
                    </Spin>
                    {
                        this.modulesState.matchedLength > 0 &&   
                        <Footer />
                    }
                 </Card>
    
            </div>
        );
    }
    private refresh () {
        ModulesAction.updateDetail(this.props.match.params.id);
        ModulesAction.updateViewMatchList(this.props.match.params.id);
    }
    private goBack () {
        history.go(-1);
    }
    private onDetail=(record)=>{
        let params = {
            invoiceManageId: record.incomeInvoiceBizId
        };
        invoiceManage.getInvoiceByBizId(this, params).then((response: any) => {
            const err = response.er;
            const res = response.res;
            if (err) {
                return null;
            } else {
                var data = {invoiceDetail:response.res.invoiceDetail,realCheckTime:null};
                var path = {
                    pathname:`invoiceDetail/${record.incomeInvoiceBizId}`,
                    state:data,
                };
                history.push(path);
            }
        });
    }
}
export default Match;



// WEBPACK FOOTER //
// ./src/display/apps/InputSettlement/UI.ViewMatch.tsx